import type { LucideIcon } from 'lucide-react';

export type IconTileSize = 'sm' | 'md' | 'lg';
export type IconTileTone = 'primary' | 'neutral' | 'success' | 'warning' | 'error' | 'info';

export interface IconTileProps {
    icon: LucideIcon;
    size?: IconTileSize;
    tone?: IconTileTone;
    className?: string;
}

const SIZE_CLASSES: Record<IconTileSize, { tile: string; icon: string }> = {
    sm: { tile: 'size-10 rounded-lg', icon: 'size-5' },
    md: { tile: 'size-12 rounded-xl', icon: 'size-6' },
    lg: { tile: 'size-14 rounded-xl', icon: 'size-7' },
};

const TONE_CLASSES: Record<IconTileTone, string> = {
    primary: 'bg-mp-primary-content text-mp-link',
    neutral: 'bg-mp-secondary-content text-mp-secondary',
    success: 'bg-mp-success-content text-mp-success',
    warning: 'bg-mp-warning-content text-mp-warning',
    error: 'bg-mp-error-content text-mp-error',
    info: 'bg-mp-info-content text-mp-info',
};

/** Decorative: hidden from assistive tech, so the surrounding text must carry the meaning. */
export function IconTile({ icon: Icon, size = 'md', tone = 'primary', className = '' }: IconTileProps) {
    const sizes = SIZE_CLASSES[size];
    return (
        <span
            aria-hidden="true"
            className={`inline-flex shrink-0 items-center justify-center ${sizes.tile} ${TONE_CLASSES[tone]} ${className}`.trim()}
        >
            <Icon className={sizes.icon} />
        </span>
    );
}
